export default __webpack_public_path__ + "static/media/writing.17f5d50c.jpg";